/**
 *
 * @type {Storage}
 */
const localStorageProxy = window.localStorage;


export default localStorageProxy;